export default __webpack_public_path__ + "static/media/life1.150eb602.png";